var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.attrs.id)?_c('div',{staticClass:"C-audio-player C-audio-player--lead"},[_c('player',[_c('div',{attrs:{"id":_vm.containerId}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }